// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
// 工作台
import indexs from '@/views/index/index';
/**
 * 基础菜单
 */
// 商品管理
import Goods from '@/views/goods/Goods';
// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 经销商管理
import distributor from '@/views/system/distributor';

// 客户管理
import customer from '@/views/system/customer';
import engineering from '@/views/system/engineering';

// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
// 管理员
import administrators from '@/views/system/administrators';
// 账号关联身份
import accountAssociated from '@/views/system/accountAssociated';


/**
 * 导购知识
 */

//客户案例管理
import customerCase from '@/views/knowledge/customerCase';
import customerCaseCallback from '@/views/knowledge/customerCaseCallback';
//产品介绍
import product from '@/views/knowledge/product';
import product1 from '@/views/knowledge/product1';
import product2 from '@/views/knowledge/product2';
import product3 from '@/views/knowledge/product3';
import product4 from '@/views/knowledge/product4';
import productadd4 from '@/views/knowledge/productadd4';
import productadd2 from '@/views/knowledge/productadd2';
import productadd3 from '@/views/knowledge/productadd3';
//价目
import retailprice from '@/views/markedprice/retailprice';
import guideprice from '@/views/markedprice/guideprice';
//推荐用户资料
import advertisement from '@/views/userprofile/advertisement';
import advertisementadd from '@/views/userprofile/advertisementadd';
import categories from '@/views/userprofile/categories';
import categoriesadd from '@/views/userprofile/categoriesadd';
import prodrecommend from '@/views/userprofile/prodrecommend';
import prodrecommendadd from '@/views/userprofile/prodrecommendadd';
import actrecommend from '@/views/userprofile/actrecommend';
import actrecommendadd from '@/views/userprofile/actrecommendadd';

//导购工具
import card from '@/views/guidetool/card';
import businesscard from '@/views/guidetool/businesscard';
import businesscardx from '@/views/guidetool/businesscardx';
import meeting from '@/views/guidetool/meeting';
import meetingadd from '@/views/guidetool/meetingadd';
import sign from '@/views/guidetool/sign';
import signadd from '@/views/guidetool/signadd';
import scheme from '@/views/guidetool/scheme';
import schemeadd from '@/views/guidetool/schemeadd';

//竞品管理
import competitive from '@/views/knowledge/competitive';

//考核数据
import residentData from '@/views/assessment/residentData';
import residentDataAdd from '@/views/assessment/residentDataAdd';
import representTownData from '@/views/assessment/representTownData';
import representTownDataAdd from '@/views/assessment/representTownDataAdd';
import businessData from '@/views/assessment/businessData';
import businessDataAdd from '@/views/assessment/businessDataAdd';
import dealerData from '@/views/assessment/dealerData';
import dealerDataAdd from '@/views/assessment/dealerDataAdd';
import regionalManager from '@/views/assessment/regionalManager';
import regionalManagerHouse from '@/views/assessment/regionalManagerHouse';
import regionalManagerBusiness from '@/views/assessment/regionalManagerBusiness';
import regionalDirector from '@/views/assessment/regionalDirector';
import regionalDirectorHouse from '@/views/assessment/regionalDirectorHouse';
import regionalDirectorBusiness from '@/views/assessment/regionalDirectorBusiness';
import assessmentDetails from '@/views/assessment/assessmentDetails';
import targetImport from '@/views/assessment/targetImport';
import homeBusinessVisit from '@/views/assessment/homeBusinessVisit';
import homeBusinessVisitadd from '@/views/assessment/homeBusinessVisitadd';
import commercialBusinessVisit from '@/views/assessment/commercialBusinessVisit';
import commercialBusinessVisitadd from '@/views/assessment/commercialBusinessVisitadd';
import engineeringProject from '@/views/assessment/engineeringProject';
import engineeringProjectadd from '@/views/assessment/engineeringProjectadd';

//案例管理
import installation from '@/views/management/installation';
import installationadd from '@/views/management/installationadd';
import installationbian from '@/views/management/installationbian';
//用户回访
import returnvisit from '@/views/management/returnvisit';
import returnvisitadd from '@/views/management/returnvisitadd';
import returnvisitbian from '@/views/management/returnvisitbian';
import callbackexamine from '@/views/management/callbackexamine';


//人员管理
import residency from '@/views/staffmanagement/residency';
import residencyadd from '@/views/staffmanagement/residencyadd';
import residentTown from '@/views/staffmanagement/residentTown';
import residentTownadd from '@/views/staffmanagement/residentTownadd';
import business from '@/views/staffmanagement/business';
import businessadd from '@/views/staffmanagement/businessadd';
import salesdirector from '@/views/staffmanagement/salesdirector';
import regionalDirectorManagement from '@/views/staffmanagement/regionalDirectorManagement';
import regionalManagerManagement from '@/views/staffmanagement/regionalManagerManagement';

/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';
import Product1 from '../views/knowledge/product1.vue';
//物料通知管理
import notificationClassification from '@/views/notificationManager/notificationClassification';



// 启用路由
Vue.use(Router);

// 导出路由 
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/index/index',
            name: '首页',
            component: indexs,
            meta: {
                requireAuth: true
            }
        },{
            path: '/goods/Goods',
            name: '商品管理',
            component: Goods,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/Machine',
            name: '机器信息管理',
            component: Machine,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineAisle',
            name: '货道信息管理',
            component: MachineAisle,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/distributor',
            name: '经销商管理',
            component: distributor,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/customer',
            name: '客户管理',
            component: customer,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/engineering',
            name: '工程用户管理',
            component: engineering,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/competitive',
            name: '竞品管理',
            component: competitive,
            meta: {
                requireAuth: true
            }
        }, { 
            path: '/product',
            name: '产品介绍',
            component: product,
            meta: {
                requireAuth: true
            }
        }, { 
            path: '/product1',
            name: '产品卖点',
            component: Product1,
            meta: {
                requireAuth: true
            }
        }, { 
            path: '/product2',
            name: '导购知识视频',
            component: product2,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/product3',
            name: '导购文件',
            component: product3,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/product4',
            name: '导购分类',
            component: product4,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/productadd4',
            name: '新增导购分类',
            component: productadd4,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/productadd2',
            name: '新增导购知识视频',
            component: productadd2,
            meta: {
                requireAuth: true
            }        
        } ,{ 
            path: '/productadd3',
            name: '新增导购文件',
            component: productadd3,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/retailprice',
            name: '全国统一零售价',
            component: retailprice,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/guideprice',
            name: '采暖套餐指导价',
            component: guideprice,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/advertisement',
            name: '广告管理',
            component: advertisement,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/advertisementadd',
            name: '广告管理新增',
            component: advertisementadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/categories',
            name: '分类推荐',
            component: categories,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/categoriesadd',
            name: '分类推荐新增',
            component: categoriesadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/prodrecommend',
            name: '产品推荐',
            component: prodrecommend,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/actrecommend',
            name: '活动推荐',
            component: actrecommend,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/prodrecommendadd',
            name: '产品推荐新增',
            component: prodrecommendadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/actrecommendadd',
            name: '活动推荐新增',
            component: actrecommendadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/card',
            name: '名片管理',
            component: card,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/businesscard',
            name: '默认名片',
            component: businesscard,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/businesscardx',
            name: '名片详情',
            component: businesscardx,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/meeting',
            name: '订购会预报',
            component: meeting,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/meetingadd',
            name: '订购会预报新增',
            component: meetingadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/sign',
            name: '签约管理',
            component: sign,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/signadd',
            name: '签约管理详情',
            component: signadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/scheme',
            name: '方案设计',
            component: scheme,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/schemeadd',
            name: '方案设计详情',
            component: schemeadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/residency',
            name: '驻村代表',
            component: residency,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/residencyadd',
            name: '驻村代表详情',
            component: residencyadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/residentTown',
            name: '驻镇代表',
            component: residentTown,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/residentTownadd',
            name: '驻镇代表详情',
            component: residentTownadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/business',
            name: '业务代表',
            component: business,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/businessadd',
            name: '业务代表新增',
            component: businessadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/salesdirector',
            name: '销售经理',
            component: salesdirector,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/regionalManagerManagement',
            name: '区域经理',
            component: regionalManagerManagement,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/regionalDirectorManagement',
            name: '大区总监',
            component: regionalDirectorManagement,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/accountAssociated',
            name: '账号关联身份',
            component: accountAssociated,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/assessmentDetails',
            name: '考核明细导入',
            component: assessmentDetails,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/targetImport',
            name: '目标设置',
            component: targetImport,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/homeBusinessVisit',
            name: '家用新商拜访',
            component: homeBusinessVisit,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/homeBusinessVisitadd',
            name: '家用新商拜访详情',
            component: homeBusinessVisitadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/commercialBusinessVisit',
            name: '商用新商拜访',
            component: commercialBusinessVisit,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/commercialBusinessVisitadd',
            name: '商用新商拜访详情',
            component: commercialBusinessVisitadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/engineeringProject',
            name: '工程项目信息',
            component: engineeringProject,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/engineeringProjectadd',
            name: '工程项目信息详情',
            component: engineeringProjectadd,
            meta: {
                requireAuth: true
            }        
        },{ 
            path: '/customerCase',
            name: '精品案例',
            component: customerCase,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/residentData',
            name: '驻村代表',
            component: residentData,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/residentDataAdd',
            name: '驻村代表详情',
            component: residentDataAdd,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/representTownData',
            name: '驻镇代表',
            component: representTownData,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/representTownDataAdd',
            name: '驻镇代表详情',
            component: representTownDataAdd,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/businessData',
            name: '业务代表',
            component: businessData,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/businessDataAdd',
            name: '业务代表详情',
            component: businessDataAdd,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/dealerData',
            name: '经销商',
            component: dealerData,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/dealerDataAdd',
            name: '经销商详情',
            component: dealerDataAdd,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/regionalManager',
            name: '区域经理',
            component: regionalManager,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/regionalManagerHouse',
            name: '区域经理家用详情',
            component: regionalManagerHouse,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/regionalManagerBusiness',
            name: '区域经理商用详情',
            component: regionalManagerBusiness,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/regionalDirector',
            name: '大区总监',
            component: regionalDirector,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/regionalDirectorHouse',
            name: '大区总监家用详情',
            component: regionalDirectorHouse,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/regionalDirectorBusiness',
            name: '大区总监商用详情',
            component: regionalDirectorBusiness,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/installation',
            name: '安装案例',
            component: installation,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/installationadd',
            name: '安装案例新增',
            component: installationadd,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/installationbian',
            name: '安装案例详情',
            component: installationbian,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/returnvisit',
            name: '用户回访',
            component: returnvisit,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/returnvisitadd',
            name: '用户回访新增',
            component: returnvisitadd,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/returnvisitbian',
            name: '用户回访编辑',
            component: returnvisitbian,
            meta: {
                requireAuth: true
            }
        },{ 
            path: '/callbackexamine',
            name: '案例回访审核',
            component: callbackexamine,
            meta: {
                requireAuth: true
            }
        }, { 
            path: '/customerCaseCallback',
            name: '用户回访',
            component: customerCaseCallback,
            meta: {
                requireAuth: true
            } 
        }, { 
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/administrators',
            name: '后台账号管理',
            component: administrators,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineConfig',
            name: '支付配置信息',
            component: MachineConfig,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Config',
            name: '支付配置',
            component: Config,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        },{
            path: '/notificationClassification',
            name: '通知分类',
            component: notificationClassification,
            meta: {
                requireAuth: true
            }
        }]
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js